'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.RE_LOAD_FAIL = exports.RE_LOAD = exports.APPEND_LOAD_FAIL = exports.APPEND_LOAD_SUCCESS = exports.APPEND_LOAD = exports.PAGE_LOAD_FAIL = exports.PAGE_LOAD_SUCCESS = exports.PAGE_LOAD = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.hasFullAsset = hasFullAsset;
exports.hasAsset = hasAsset;
exports.getAcquiredAssets = getAcquiredAssets;
exports.getFavorites = getFavorites;
exports.addToFavorites = addToFavorites;
exports.removeFromFavorites = removeFromFavorites;
exports.loadFreeAssetsDrop = loadFreeAssetsDrop;
exports.loadAssetsPage = loadAssetsPage;
exports.loadFullAsset = loadFullAsset;
exports.resetSuggestTag = resetSuggestTag;
exports.suggestTag = suggestTag;
exports.resetReportAsset = resetReportAsset;
exports.reportAsset = reportAsset;
exports.getCategoryAssetCount = getCategoryAssetCount;
exports.setIsArchviz = setIsArchviz;
exports.getFeatured = getFeatured;

var _auth = require('./auth');

var _assetDownloads = require('./assetDownloads');

var _utils = require('utils');

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _config = require('../../config');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAGE_LOAD = exports.PAGE_LOAD = 'ms/assets/page_load';
var PAGE_LOAD_SUCCESS = exports.PAGE_LOAD_SUCCESS = 'ms/assets/page_load_success';
var PAGE_LOAD_FAIL = exports.PAGE_LOAD_FAIL = 'ms/assets/page_load_fail';

var APPEND_LOAD = exports.APPEND_LOAD = 'ms/assets/append_load';
var APPEND_LOAD_SUCCESS = exports.APPEND_LOAD_SUCCESS = 'ms/assets/append_load_success';
var APPEND_LOAD_FAIL = exports.APPEND_LOAD_FAIL = 'ms/assets/append_load_fail';
var RE_LOAD = exports.RE_LOAD = 'ms/assets/re_load';
var RE_LOAD_FAIL = exports.RE_LOAD_FAIL = 'ms/assets/re_load_fail';

var LOAD = 'ms/assets/load';
var LOAD_SUCCESS = 'ms/assets/load_success';
var LOAD_FAIL = 'ms/assets/load_fail';

var REPORT_INIT = 'ms/assets/report_init';
var REPORT = 'ms/assets/report';
var REPORT_SUCCESS = 'ms/assets/report_success';
var REPORT_FAIL = 'ms/assets/report_fail';

var SUGGEST_INIT = 'ms/assets/suggest_init';
var SUGGEST_TAG = 'ms/assets/suggest_tag';
var SUGGEST_TAG_SUCCESS = 'ms/assets/suggest_tag_success';
var SUGGEST_TAG_FAIL = 'ms/assets/suggest_tag_fail';

var ADD_FAV = 'ms/assets/add_to_favorites';
var ADD_FAV_SUCCESS = 'ms/assets/add_to_favorites_success';
var ADD_FAV_FAIL = 'ms/assets/add_to_favorites_fail';

var REMOVE_FAV = 'ms/assets/remove_from_favorites';
var REMOVE_FAV_SUCCESS = 'ms/assets/remove_from_favorites_success';
var REMOVE_FAV_FAIL = 'ms/assets/remove_from_favorites_fail';

var GET_FAVORITES = 'ms/assets/get_favorites';
var GET_FAVORITES_SUCCESS = 'ms/assets/get_favorites_success';
var GET_FAVORITES_FAIL = 'ms/assets/get_favorites_fail';

var GET_ACQUIRED = 'ms/assets/get_acquired';
var GET_ACQUIRED_SUCCESS = 'ms/assets/get_acquired_success';
var GET_ACQUIRED_FAIL = 'ms/assets/get_acquired_fail';

var GET_CATEGORY_TREE = 'ms/assets/get_category_tree';
var GET_CATEGORY_TREE_SUCCESS = 'ms/assets/get_category_tree_success';
var GET_CATEGORY_TREE_FAIL = 'ms/assets/get_category_tree_fail';

var GET_FEATURED = 'ms/assets/get_featured';
var GET_FEATURED_SUCCESS = 'ms/assets/get_featured_success';
var GET_FEATURED_FAIL = 'ms/assets/get_featured_fail';

var GOT_FREE_ASSETS_DROP = 'ms/assets/got_free_drops';
var SET_IS_ARCHVIZ = 'ms/assets/set_is_archviz';

var loadingPromise = void 0;

var initialState = {
	assets: {},
	options: {},
	pages: 0,

	fullAssets: {},
	fullLoading: false,

	loading: true,
	appendLoading: false,
	loadingError: null,

	reportingAsset: false,
	assetReported: false,
	assetBeingReported: null,
	reportAssetError: null,

	favorites: [],
	acquired: [],

	cachedAssets: {},
	freeAssetDrop: null,
	categoryTree: [],
	featured: [],

	initialized: false,

	isArchviz: false
};

var fullAssets = void 0;

var addToAssetObj = function addToAssetObj(categories, data) {
	if (data && categories.indexOf(data) === -1) {
		categories.push(data);
	}
};

var getCloudFrontUri = function getCloudFrontUri(uri) {
	return uri && !_ramda2.default.isEmpty(uri) ? _config.assetsCloudFrontUrl + '/' + _ramda2.default.replace('/quixel-megascans-assets/', '', uri) : undefined;
};

var getThumbJpg = function getThumbJpg(assetType, previews) {
	var _preview = void 0;
	if (assetType === '3d') {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('highpoly') > -1 && preview.tags.indexOf('thumb') > -1 && preview.tags.indexOf('jpeg') > -1;
		});
	} else {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('thumb') > -1 && preview.tags.indexOf('jpeg') > -1;
		});
	}
	return _preview && _preview.uri || _preview;
};

var getThumbPng = function getThumbPng(assetType, previews) {
	var _preview = void 0;
	if (assetType === '3d') {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('highpoly') > -1 && preview.tags.indexOf('thumb') > -1 && preview.tags.indexOf('jpeg') === -1;
		});
	} else {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('thumb') > -1 && preview.tags.length === 1;
		});
	}
	return _preview && _preview.uri || _preview;
};

var getTiny = function getTiny(previews) {
	var _preview = previews.find(function (preview) {
		return preview.uri.indexOf('data:') === 0;
	});
	return _preview && _preview.uri || _preview;
};

var getPreview = function getPreview(assetType, previews) {
	var _preview = void 0;
	if (assetType === '3d') {
		_preview = previews.find(function (preview) {
			return preview.tags.length >= 2 && preview.tags.indexOf('tiny') === -1 && preview.tags.indexOf('preview') > -1 && preview.tags.indexOf('jpeg') > -1 && preview.tags.indexOf('retina') === -1 && preview.tags.indexOf('thumb') === -1;
		});
	} else {
		_preview = previews.find(function (preview) {
			return preview.tags.length >= 2 && preview.tags.indexOf('tiny') === -1 && preview.tags.indexOf('preview') > -1 && preview.tags.indexOf('jpeg') > -1 && preview.tags.indexOf('retina') === -1 && preview.tags.indexOf('cropped') === -1;
		});
	}
	return _preview && _preview.uri || _preview;
};

var getThumbRetinaJpg = function getThumbRetinaJpg(assetType, previews) {
	var _preview = void 0;
	if (assetType === '3d') {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('thumb') > -1 && preview.tags.indexOf('retina') > -1 && preview.tags.indexOf('jpeg') > -1 && preview.tags.length === 3;
		});
	} else {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('thumb') > -1 && preview.tags.indexOf('retina') > -1;
		});
	}
	return _preview && _preview.uri || _preview;
};

var getThumbRetinaPng = function getThumbRetinaPng(assetType, previews) {
	var _preview = void 0;
	if (assetType === '3d') {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('preview') > -1 && preview.tags.indexOf('retina') > -1 && preview.tags.length === 2;
		});
	} else {
		_preview = previews.find(function (preview) {
			return preview.tags.indexOf('thumb') > -1 && preview.tags.indexOf('retina') > -1 && preview.tags.length === 2;
		});
	}
	return _preview && _preview.uri || _preview;
};

var transformAssetsFetchedFromAPI = function transformAssetsFetchedFromAPI(apiResponse) {
	var searchString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

	var assets = apiResponse.assets.map(function (asset) {
		asset.tags = asset.tags || asset._tags;
		asset._id = asset._id || asset.id;

		if (!asset.categories) {
			var categories = [asset.type];
			addToAssetObj(categories, asset.category);
			addToAssetObj(categories, asset.subCategory);
			addToAssetObj(categories, asset.subCategory2);
			addToAssetObj(categories, asset.subCategory3);
			asset.categories = categories;
		}

		if (asset.previews.images && asset.previews.images.length) {
			asset.previews.images = {
				preview: getCloudFrontUri(getPreview(asset.categories[0], asset.previews.images)),
				thumb: getCloudFrontUri(getThumbPng(asset.categories[0], asset.previews.images)),
				thumbJpg: getCloudFrontUri(getThumbJpg(asset.categories[0], asset.previews.images)),
				tiny: getTiny(asset.previews.images),
				thumbRetinaJpg: getCloudFrontUri(getThumbRetinaJpg(asset.categories[0], asset.previews.images)),
				thumbRetina: getCloudFrontUri(getThumbRetinaPng(asset.categories[0], asset.previews.images))
			};
		}

		return asset;
	});

	return {
		assets: assets,
		tags: apiResponse.facets && apiResponse.facets._tags || [],
		pages: apiResponse.pages || apiResponse.nbPages,
		page: apiResponse.page,
		facets: apiResponse.facets || [],
		sort: apiResponse.sort,
		sortOrder: apiResponse.sortOrder,
		requestQuery: searchString
	};
};

function reducer() {
	var _Immutable$List, _Immutable$List2;

	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var assets = void 0;
	switch (action.type) {
		case PAGE_LOAD:
			return (0, _extends4.default)({}, state, {
				assets: {},
				options: action.meta.options,
				loading: true,
				loadingError: null,
				loadNotFound: false
			});

		case PAGE_LOAD_SUCCESS:
		case RE_LOAD:
			if (action.result.canceled) return state;
			var view = action.meta.options.view;
			if (!view || view === 'latest') {
				view = '';
			}
			// assets = filterAssetsByView(action.result.assets, view, state)
			var cachedResultsPage = state.cachedAssets;
			var result = action.result;
			// if (view === 'myscans' || view === 'favorited') {
			//   result = transformAssetsFetchedFromAPI(action.result);
			// } else {

			var key = '__default__' + view + "__" + result.requestQuery;
			cachedResultsPage[key] = result;
			// }
			// assets = result.assets;
			assets = filterAssetsByView(result.assets, view, state);

			if (view === 'free' && state.freeAssetDrops) {
				assets = state.freeAssetDrops.concat(assets);
			}

			return (0, _extends4.default)({}, state, {
				options: action.meta.options,
				assets: (_Immutable$List = _immutable2.default.List).of.apply(_Immutable$List, (0, _toConsumableArray3.default)(assets)),
				page: result.page,
				pages: result.pages,
				loadNotFound: assets == 0,
				loading: false,
				loadingError: null,
				appendLoading: false,
				cachedAssets: cachedResultsPage
			});

		case PAGE_LOAD_FAIL:
			return (0, _extends4.default)({}, state, {
				loading: false,
				loadingError: action.error
			});

		case APPEND_LOAD:
			return (0, _extends4.default)({}, state, {
				options: action.meta.options,
				appendLoading: true,
				loadingError: null
			});

		case APPEND_LOAD_SUCCESS:
			if (action.result.canceled) return state;
			var assetsToAppend = action.result.assets;
			if (action.meta.options.view === 'myscans' || action.meta.options.view === 'favorited') {
				assetsToAppend = transformAssetsFetchedFromAPI(action.result).assets;
			}
			// let assetsArray = filterAssetsByView(state.assets.toArray().concat(action.result.assets), action.meta.options.view, state)
			// assets = Immutable.List.of(...assetsArray);

			assetsToAppend = state.assets.toArray().concat(assetsToAppend);
			assets = (_Immutable$List2 = _immutable2.default.List).of.apply(_Immutable$List2, (0, _toConsumableArray3.default)(assetsToAppend));

			return (0, _extends4.default)({}, state, {
				options: action.meta.options,
				assets: assets,
				page: action.result.page,
				pages: action.result.pages,
				appendLoading: false,
				loadingError: null
			});

		case APPEND_LOAD_FAIL:
			return (0, _extends4.default)({}, state, {
				appendLoading: false,
				loadingError: action.error
			});

		case GOT_FREE_ASSETS_DROP:

			var cache = state.cachedAssets;
			cache["__default__free__"] = null;

			return (0, _extends4.default)({}, state, {
				freeAssetDrops: action.result,
				cachedAssets: cache
			});

		case LOAD:
			return (0, _extends4.default)({}, state, {
				fullLoading: true,
				loadingError: null
			});

		case LOAD_SUCCESS:

			fullAssets = (0, _extends4.default)({}, state.fullAssets);
			fullAssets[action.result.asset.id] = action.result.asset;

			return (0, _extends4.default)({}, state, {
				fullLoading: false,
				loadingError: null,
				fullAssets: fullAssets
			});

		case LOAD_FAIL:
			return (0, _extends4.default)({}, state, {
				fullLoading: false,
				loadingError: action.error
			});

		case _auth.LOGIN_SUCCESS:
		case _auth.LOGOUT_SUCCESS:
			var freeAssetDrops = state.freeAssetDrops;

			var newAssets = state.assets;
			var newFreeAssetDrops = state.freeAssetDrops;

			if (action.type === _auth.LOGOUT_SUCCESS) {
				if (!_underscore2.default.isEmpty(freeAssetDrops)) {
					newAssets = newAssets.filter(function (a) {
						return freeAssetDrops.find(function (fad) {
							return fad.id === a.id;
						});
					});
					newFreeAssetDrops = null;
				}
			}

			return (0, _extends4.default)({}, state, {
				assets: newAssets,
				fullAssets: {},
				favorites: [],
				acquired: [],
				freeAssetDrops: newFreeAssetDrops
			});

		case _assetDownloads.ASSET_ACQUIRE_SUCCESS:
			return (0, _extends4.default)({}, state, {
				assets: state.assets && state.assets.size && state.assets.update(state.assets.findIndex(function (i) {
					return i.id == action.meta.assetId;
				}), function (i) {
					return (0, _extends4.default)({}, i, {
						acl: {
							resolution: action.meta.resolution,
							exrAccess: action.meta.exrAccess
						}
					});
				}),
				fullAssets: (0, _extends4.default)({}, state.fullAssets, (0, _defineProperty3.default)({}, action.result.assetID, (0, _extends4.default)({}, state.fullAssets[action.result.assetID], {
					acl: {
						resolution: action.meta.resolution,
						exrAccess: action.meta.exrAccess
					}
				}))),
				acquired: state.acquired.concat(action.meta.assetId)
			});

		case SUGGEST_INIT:
			return (0, _extends4.default)({}, state, {
				suggestingTag: false,
				tagSuggested: false,
				suggestTagError: null
			});

		case SUGGEST_TAG:
			return (0, _extends4.default)({}, state, {
				suggestingTag: true,
				tagSuggested: false,
				suggestTagError: null
			});

		case SUGGEST_TAG_SUCCESS:
			return (0, _extends4.default)({}, state, {
				suggestingTag: false,
				tagSuggested: true,
				suggestTagError: null
			});

		case SUGGEST_TAG_FAIL:
			return (0, _extends4.default)({}, state, {
				suggestingTag: false,
				tagSuggested: false,
				suggestTagError: action.error
			});

		case REPORT_INIT:
			return (0, _extends4.default)({}, state, {
				reportingAsset: false,
				assetReported: false,
				reportAssetError: null,
				assetBeingReported: null
			});

		case REPORT:
			return (0, _extends4.default)({}, state, {
				reportingAsset: true,
				assetReported: false,
				reportAssetError: null,
				assetBeingReported: action.assetId
			});

		case REPORT_SUCCESS:
			return (0, _extends4.default)({}, state, {
				reportingAsset: false,
				assetReported: true,
				assetBeingReported: action.assetId
			});

		case REPORT_FAIL:
			return (0, _extends4.default)({}, state, {
				reportingAsset: false,
				assetReported: false,
				reportAssetError: action.error,
				assetBeingReported: action.assetId
			});

		case ADD_FAV:
			return (0, _extends4.default)({}, state, {
				favorites: state.favorites.indexOf(action.meta.assetId) == -1 ? [].concat((0, _toConsumableArray3.default)(state.favorites), [action.meta.assetId]) : state.favorites
			});

		case ADD_FAV_SUCCESS:
			return (0, _extends4.default)({}, state, {
				favorites: state.favorites.indexOf(action.meta.assetId) == -1 ? [].concat((0, _toConsumableArray3.default)(state.favorites), [action.meta.assetId]) : state.favorites
			});

		case REMOVE_FAV:
			return (0, _extends4.default)({}, state, {
				favorites: state.favorites.filter(function (item, index) {
					return item !== action.meta.assetId;
				})
			});
		case REMOVE_FAV_SUCCESS:
			return (0, _extends4.default)({}, state, {
				favorites: state.favorites.filter(function (item, index) {
					return item !== action.meta.assetId;
				})
			});

		case GET_ACQUIRED:
			return (0, _extends4.default)({}, state, {
				loadingAcquiredAssets: true
			});

		case GET_ACQUIRED_SUCCESS:
			return (0, _extends4.default)({}, state, {
				acquired: action.result.acquired,
				loadingAcquiredAssets: false
			});

		case GET_ACQUIRED_FAIL:
			return (0, _extends4.default)({}, state, {
				loadingAcquiredAssets: false,
				loadingAcquiredAssetsError: action.result
			});

		case GET_FAVORITES:
			return (0, _extends4.default)({}, state, {
				loadingFavorites: true
			});

		case GET_FAVORITES_SUCCESS:
			return (0, _extends4.default)({}, state, {
				loadingFavorites: false,
				favorites: action.result.favorites
			});

		case GET_FAVORITES_FAIL:
			return (0, _extends4.default)({}, state, {
				loadingFavorites: false,
				loadingFavoritesError: action.result
			});

		case GET_CATEGORY_TREE_SUCCESS:
			var categoryTree = action.result;
			var categoriesList = [];
			(0, _keys2.default)(categoryTree).map(function (key, index) {
				if ((0, _typeof3.default)(categoryTree[key]) == 'object') {
					var k = key.toLowerCase();
					var isAll = key == "all";
					var count = isAll ? categoryTree[key] - 1001 : categoryTree[key]._nbHits;
					var categoryObj = {
						label: k,
						count: count,
						subCategories: []
					};
					for (var subkey in categoryTree[key]) {
						if ((0, _typeof3.default)(categoryTree[key][subkey]) === 'object') {
							count = categoryTree[key][subkey]._nbHits;
							categoryObj.subCategories.push({
								label: subkey.toLowerCase(),
								count: count
							});
						}
					}
					categoryObj.subCategories = categoryObj.subCategories.sort(function (a, b) {
						return a.label > b.label ? 1 : -1;
					});
					categoriesList.push(categoryObj);
				} else if (key == '_all') {
					categoriesList.unshift({
						label: 'all',
						count: categoryTree['_all']
					});
				}
			});
			categoriesList = categoriesList.sort(function (a, b) {
				return a.label > b.label ? 1 : -1;
			});
			return (0, _extends4.default)({}, state, {
				categoryTree: categoriesList,
				initialized: true
			});
		case GET_FEATURED:
			return (0, _extends4.default)({}, state, {
				loadingFeatured: true
			});

		case GET_FEATURED_SUCCESS:
			return (0, _extends4.default)({}, state, {
				loadingFeatured: false,
				featured: action.result.featured
			});
		case GET_FEATURED_FAIL:
			return (0, _extends4.default)({}, state, {
				loadingFeatured: false
			});
		case SET_IS_ARCHVIZ:
			return (0, _extends4.default)({}, state, {
				isArchviz: action.data
			});
		default:
			return state;
	}
}

// Helper functions

function hasFullAsset(globalState, id) {
	return !!globalState.assets.fullAssets[id];
}

function hasAsset(globalState, id) {
	return !!globalState.assets.assets.find(function (a) {
		return a.id === id;
	});
}

// Action creators
function getAcquiredAssets() {
	return function (dispatch, getState) {
		var acquiredExists = getState().assets.acquired && getState().assets.acquired.length > 0;
		if (acquiredExists || !getState().auth.loggedIn) return;

		return dispatch({
			types: [GET_ACQUIRED, GET_ACQUIRED_SUCCESS, GET_ACQUIRED_FAIL],
			promise: function promise(client) {
				return client.get('v1/assets/acquired').then(function (result) {
					return {
						acquired: result.map(function (asset) {
							return asset.assetID;
						})
					};
				});
			}
		});
	};
}

function getFavorites() {
	return function (dispatch, getState) {
		var favoritesExist = getState().assets.favorites && getState().assets.favorites.length > 0;
		if (favoritesExist || !getState().auth.loggedIn) return;

		return dispatch({
			types: [GET_FAVORITES, GET_FAVORITES_SUCCESS, GET_FAVORITES_FAIL],
			promise: function promise(client) {
				return client.get('v1/assets/favorites');
			}
		});
	};
}

function addToFavorites(id) {
	return {
		types: [ADD_FAV, ADD_FAV_SUCCESS, ADD_FAV_FAIL],
		meta: {
			assetId: id
		},
		promise: function promise(client) {
			return client.post('v1/assets/favorites/' + id).then(function (result) {
				return {
					fav: result
				};
			});
		}
	};
}

function removeFromFavorites(id) {
	return {
		types: [REMOVE_FAV, REMOVE_FAV_SUCCESS, REMOVE_FAV_FAIL],
		meta: {
			assetId: id
		},
		promise: function promise(client) {
			return client.delete('v1/assets/favorites/' + id).then(function (result) {
				return {
					fav: result
				};
			});
		}
	};
}
function loadFreeAssetsDrop(filterAssetIds) {
	return function (dispatch, getState) {
		var state = getState().assets;
		if (!state.freeAssetDrop && filterAssetIds) {
			getFilteredAssetsFromAlgolia("", 50, "", filterAssetIds).then(function (result) {

				var hits = result.hits;
				var obj = void 0;
				var assets = [];
				var categories = [];
				for (var i = 0; i < hits.length; i++) {
					obj = hits[i];
					obj.tags = obj._tags;
					obj._id = obj.id;
					categories = [obj.type];
					addToAssetObj(categories, obj.category);
					addToAssetObj(categories, obj.subCategory);
					addToAssetObj(categories, obj.subCategory2);
					addToAssetObj(categories, obj.subCategory3);

					obj.categories = categories;
					assets.push(obj);
				}

				return dispatch({
					type: GOT_FREE_ASSETS_DROP,
					result: assets
				});
			});
		}
	};
}
function loadAssetsPage(options, append, isArchViz, reload) {
	return function (dispatch, getState) {
		var state = getState().assets;
		var currentOptions = state.options;
		var pages = state.pages;
		var omitPage = _ramda2.default.omit(['page']);

		var type = options.type ? options.type.toLowerCase() : '';
		var pack = options.pack ? options.pack.toLowerCase() : options.collectionId ? options.collectionId.toLowerCase() : '';
		var biome = options.biome ? options.biome.toLowerCase() : '';
		var region = options.region ? options.region.toLowerCase() : '';

		var category = options.category ? options.category.toLowerCase() : '';
		var subCategory = options.subCategory ? options.subCategory.toLowerCase() : '';

		var toSearch = [];
		var view = options.view;

		if (options.search && options.search.length) {
			if (typeof options.search === 'string') {
				toSearch.push(options.search.toLowerCase());
			} else {
				var _searches = options.search;
				for (var i = 0; i < _searches.length; i += 1) {
					toSearch.push(_searches[i].toLowerCase());
				}
			}
		}
		if (isArchViz && view !== 'myscans' && view !== 'favorited') {
			toSearch.push('archviz');
		}

		var searches = _underscore2.default.compact(_underscore2.default.flatten([].concat(category).concat(subCategory).concat(type).concat(pack).concat(biome).concat(region).concat(toSearch)));

		//sort search
		searches = searches.sort(function (a, b) {
			return a > b ? 1 : -1;
		});

		//unique only
		searches = searches.filter(function (value, index, self) {
			return self.indexOf(value) === index;
		});

		var newOptions = (0, _extends4.default)({}, options, {
			category: undefined,
			subCategory: undefined,
			type: undefined,
			pack: undefined,
			biome: undefined,
			region: undefined,
			search: searches.length > 0 ? searches : undefined
		});

		if (!reload && _ramda2.default.equals(currentOptions, omitPage(newOptions))) {
			if (!append) {
				return null;
			}
			if (pages && newOptions.page && pages < newOptions.page) {
				return null;
			}
		}

		var searchString = searches.join(' ').trim();

		if (!view || view === 'latest') {
			view = '';
		}

		if (!reload && !append) {
			//check cache
			var cacheKey = '__default__' + view + "__" + searchString;

			var cachedAssetsForFilter = state.cachedAssets[cacheKey];

			if (cachedAssetsForFilter) {
				dispatch({
					type: PAGE_LOAD_SUCCESS,
					meta: {
						options: omitPage(newOptions)
					},
					result: cachedAssetsForFilter
				});
			}
		}

		dispatch({
			type: append ? APPEND_LOAD : PAGE_LOAD,
			meta: {
				options: omitPage(newOptions)
			}
		});

		if (view === 'myscans' || view === 'favorited' || newOptions.filter) {
			var ids = newOptions.filter;
			if (view == 'myscans') {
				ids = state.acquired;
			} else if (view == 'favorited') {
				ids = state.favorites;
			}

			if (!reload && !ids || !ids.length) return;

			return getFilteredAssetsFromAlgolia(searchString, 50, newOptions.page, ids).then(function (result) {
				var currentState = getState();
				var currentOptions = currentState.assets.options;

				if (currentOptions.view !== newOptions.view) {
					return {
						canceled: true
					};
				}

				var hits = result.hits;
				var obj = void 0;
				var assets = [];
				var categories = [];
				for (var i = 0; i < hits.length; i++) {
					obj = hits[i];
					obj.tags = obj._tags;
					obj._id = obj.id;
					categories = [obj.type];
					addToAssetObj(categories, obj.category);
					addToAssetObj(categories, obj.subCategory);
					addToAssetObj(categories, obj.subCategory2);
					addToAssetObj(categories, obj.subCategory3);

					obj.categories = categories;
					assets.push(obj);
				}

				var resultObj = {
					assets: assets,
					tags: result.facets._tags || [],
					pages: result.nbPages,
					page: result.page,
					facets: result.facets || [],
					sort: result.sort,
					sortOrder: result.sortOrder,
					requestQuery: searchString
				};

				return dispatch({
					type: reload ? RE_LOAD : append ? APPEND_LOAD_SUCCESS : PAGE_LOAD_SUCCESS,
					meta: {
						options: omitPage(newOptions)
					},
					result: resultObj
				});
			}).catch(function (err) {
				console.log("Error:", err);
				return dispatch({
					type: append ? APPEND_LOAD_FAIL : PAGE_LOAD_FAIL,
					meta: {
						options: omitPage(newOptions)
					},
					result: err
				});
			});
		}

		return getAssetsFromServer(searchString, view, newOptions.page, pack, options.count).then(function (result) {
			var currentState = getState();
			var currentOptions = currentState.assets.options;

			if (currentOptions.view !== newOptions.view) {
				return {
					canceled: true
				};
			}

			var hits = result.hits;
			var obj = void 0;
			var assets = [];
			var categories = [];
			for (var i = 0; i < hits.length; i++) {
				obj = hits[i];
				obj.tags = obj._tags;
				obj._id = obj.id;
				categories = [obj.type];
				addToAssetObj(categories, obj.category);
				addToAssetObj(categories, obj.subCategory);
				addToAssetObj(categories, obj.subCategory2);
				addToAssetObj(categories, obj.subCategory3);

				obj.categories = categories;
				assets.push(obj);
			}

			var resultObj = {
				assets: assets,
				tags: result.facets._tags || [],
				pages: result.nbPages,
				page: result.page,
				facets: result.facets || [],
				sort: result.sort,
				sortOrder: result.sortOrder,
				requestQuery: searchString
			};

			return dispatch({
				type: reload ? RE_LOAD : append ? APPEND_LOAD_SUCCESS : PAGE_LOAD_SUCCESS,
				meta: {
					options: omitPage(newOptions)
				},
				result: resultObj
			});
		}).catch(function (err) {
			console.log("Error:", err);
			return dispatch({
				type: append ? APPEND_LOAD_FAIL : PAGE_LOAD_FAIL,
				meta: {
					options: omitPage(newOptions)
				},
				result: err
			});
		});
	};
}

function loadFullAsset(id) {
	return {
		types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
		promise: function promise(client) {
			return client.get('v1/assets/' + id).then(function (result) {
				return {
					asset: result
				};
			});
		}
	};
}

function resetSuggestTag() {
	return {
		type: SUGGEST_INIT
	};
}

function suggestTag(_ref) {
	var assetId = _ref.assetId,
	    message = _ref.message;

	return {
		types: [SUGGEST_TAG, SUGGEST_TAG_SUCCESS, SUGGEST_TAG_FAIL],
		promise: function promise(client) {
			return client.post('v1/assets/' + assetId + '/reports', {
				data: {
					message: '[TAG]' + message
				}
			});
		}
	};
}

function resetReportAsset() {
	return {
		type: REPORT_INIT
	};
}

function reportAsset(_ref2) {
	var assetId = _ref2.assetId,
	    message = _ref2.message;

	return {
		types: [REPORT, REPORT_SUCCESS, REPORT_FAIL],
		promise: function promise(client) {
			return client.post('v1/assets/' + assetId + '/reports', {
				data: {
					message: message
				}
			});
		},
		assetId: assetId,
		message: message
	};
}

function getCategoryAssetCount(isArchviz) {
	return function (dispatch, getState) {
		return dispatch({
			types: [GET_CATEGORY_TREE, GET_CATEGORY_TREE_SUCCESS, GET_CATEGORY_TREE_FAIL],
			promise: function promise(client) {
				return client.get(isArchviz ? '/v1/assets/categorytree/archviz' : '/v1/assets/categorytree/2');
			}
		});
	};
}
function setIsArchviz(isArchviz) {
	return {
		type: SET_IS_ARCHVIZ,
		data: isArchviz
	};
}

function getFeatured() {
	return function (dispatch, getState) {
		return dispatch({
			types: [GET_FEATURED, GET_FEATURED_SUCCESS, GET_FEATURED_FAIL],
			promise: function promise(client) {
				return client.get('/v1/featured');
			}
		});
	};
}
// Internal functions

function loadAssets(_ref3) {
	var state = _ref3.state,
	    page = _ref3.page,
	    view = _ref3.view,
	    search = _ref3.search,
	    count = _ref3.count;

	var ids = [];
	if (view == 'myscans') {
		ids = state.acquired;
	} else if (view == 'favorited') {
		ids = state.favorites;
	}

	return getFilteredAssetsFromAlgolia(search, count, page, ids).then(function (result) {

		return {
			assets: result.hits || [],
			tags: result.query || [],
			pages: result.nbPages,
			page: result.page,
			facets: result.facets,
			sort: null,
			sortOrder: null
		};
	});
}

function filterAssetsByView(assets, view, state) {
	var assetIds = [];
	if (view === 'favorited') {
		assetIds = state.favorites;
	} else if (view === 'myscans') {
		assetIds = state.acquired;
	} else {
		return assets;
	}
	var i = 0;
	var filteredAssets = [];
	for (; i < assets.length; i++) {
		if (assetIds.indexOf(assets[i].id) !== -1) {
			filteredAssets.push(assets[i]);
		}
	}
	return filteredAssets;
}

// function getAssetDropFromServer(filterAssetIds) {
// 	const algoliasearch = require('algoliasearch');
// 	let client = algoliasearch('6UJ1I5A072', 'd323ecb8180960ca69173bf184c8b294');
// 	const index = client.initIndex('assets');

// 	let algoliaQuery = {
//     query: '',
//     page:'',
//     hitsPerPage : 50,
//     facets: '*'
//   };


//   let filterStr = ""
//   for(let i = 0; i < filterAssetIds.length-1; i++){
//     filterStr+="objectID:" + filterAssetIds[i] +" OR "
//   }
//   filterStr+="objectID:" + filterAssetIds[filterAssetIds.length-1];

//   algoliaQuery.queryType = 'prefixLast';
//   algoliaQuery.filters = filterStr;

// 	return index.search(algoliaQuery);
// }

function getFilteredAssetsFromAlgolia(search, limit, page, idss) {
	var algoliasearch = require('algoliasearch');
	var client = algoliasearch('6UJ1I5A072', 'd323ecb8180960ca69173bf184c8b294');
	var index = client.initIndex((0, _utils2.getAlgoliaIndex)());

	var ids = idss;

	var filterStr = "";

	if (ids.length) {
		for (var i = 0; i < ids.length - 1; i++) {
			filterStr += "objectID:" + ids[i] + " OR ";
		}
		filterStr += "objectID:" + ids[ids.length - 1];
	}

	page = page || 0;
	var hitsPerPage = limit || 50;

	var opts = {
		query: search,
		queryType: 'prefixLast',
		filters: filterStr === 'undefined' ? '' : filterStr,
		facets: '*',
		page: page,
		hitsPerPage: hitsPerPage
	};

	console.log('in getFilteredAssetsFromAlgolia', opts);

	return index.search(opts);
}

function getAssetsFromServer(searchString, view, page, pack, count) {
	var algoliasearch = require('algoliasearch');
	var client = algoliasearch('6UJ1I5A072', 'd323ecb8180960ca69173bf184c8b294');
	var index = client.initIndex((0, _utils2.getAlgoliaIndex)());

	page = page || 0;
	var hitsPerPage = count || 50;
	if (view === 'favorited' || view === 'myscans') {
		hitsPerPage = 500;
	} else if (view === 'free') {
		searchString = 'free';
	}

	var opts = (0, _extends4.default)({
		query: searchString,
		hitsPerPage: hitsPerPage
	}, !_ramda2.default.isEmpty(pack) && {
		restrictSearchableAttributes: 'pack'
	}, {
		page: page,
		facets: '*'
	});

	return index.search(opts);
}

function prepareQuery(_ref4) {
	var page = _ref4.page,
	    limit = _ref4.limit,
	    sort = _ref4.sort,
	    sortOrder = _ref4.sortOrder,
	    view = _ref4.view,
	    type = _ref4.type,
	    biome = _ref4.biome,
	    region = _ref4.region,
	    category = _ref4.category,
	    subCategory = _ref4.subCategory,
	    search = _ref4.search,
	    points = _ref4.points;

	var requestQuery = {
		page: page,
		limit: limit,
		view: view,
		type: type,
		biome: biome,
		region: region,
		category: category,
		subCategory: subCategory,
		query: _ramda2.default.is(String, search) ? search : _ramda2.default.is(Array, search) ? search.join(' ') : null,
		points: points,
		sort: sort,
		sortOrder: sortOrder
	};
	var sanitizedRequestQuery = (0, _utils.cleanObj)(requestQuery);

	return _qs2.default.stringify(sanitizedRequestQuery);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/assets.js
// module id = 221
// module chunks = 0